<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'documentList' }">{{$t('entities.document.plural')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ model.name }}</el-breadcrumb-item>
            </el-breadcrumb>

            <h2 class="page-title">{{ model.name  }}</h2>

            <el-row>
                <app-file-link-list :files="model.attachments" />
            </el-row>

            <el-row>
               <embed :src="urlPdf"  height="800px" width="100%" type="application/pdf">
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
/* eslint-disable */

export default {
    name: "app-document-show",

    props: {
        id: String
    },

    data() {
        return {
            title: "Información del document",
            labels: {
                name: "Nombre document",
                emailManager: "Email de contacto",
                picture: "Escudo"
            },
            urlPdf: '',
            embedded: 'embedded=true'
        };
    },

    created() {

        this.$store
            .dispatch("entities/document/detail", this.id).then(() => {

                if (this.model.attachments.length > 0) {
                    this.urlPdf = this.model.attachments[0].url
                }
            })
            .catch(() => this.$router.push({ name: "documentList" }));
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/document/clear");
        next();
    },

    computed: {
        ...mapGetters({
            model: "entities/document/model",
            loading: "entities/document/loading",
            hasRoleToDelete: "entities/document/hasRoleToDelete",
            hasRoleToUpdate: "entities/document/hasRoleToUpdate",
            hasRoleToRead: "entities/document/hasRoleToRead",
            hasRoleToReadLogs: "entities/document/hasRoleToReadLogs",
            hasRoleToCreate: "entities/document/hasRoleToCreate",
            isMobile: "shared/isMobile",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth"
        })
    },
   
    methods: {
        edit() {
            this.$router.push({
                name: "documentEdit",
                params: { id: this.id, previous: "show" }
            });
        },

        destroy(model) {
            //eslint-disable-next-line
            this.$confirm(
                this.$t("table.areYouSure"),
                this.$t("table.confirm"),
                {
                    confirmButtonText: this.$t("table.yes"),
                    cancelButtonText: this.$t("table.no"),
                    type: "warning"
                }
            )
                .then(() =>
                    this.$store.dispatch("entities/document/destroy", model)
                )
                .then(() => this.$router.push({ name: "documentList" }))
                .catch(() => {});
        },
    }
};
</script>

<style lang="css" scoped>
  #buttons {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  /* Page content */
  .content {
    padding: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/entities/document/document-show.vue?99cb76c0